<template>
  <v-card>
    <v-card-title class="grey lighten-5 headline">
      Cadastro de Grupo
    </v-card-title>
    <v-row class="pa-4" justify="space-between">
      <v-col cols="6">
        <v-form v-model="valid" ref="form">
          <v-container>
            <v-row>
              <v-col cols="12">
                <IconeSelect :group="grupo"></IconeSelect>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  :items="departamentos"
                  label="Departamento"
                  item-text="caminhoCompleto"
                  item-value="id"
                  v-model="grupo.departamentoID"
                  :rules="[rules.required]"
                  :disabled="grupo.id !== 0"
                  required
                  @change="listaTemplates()"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="mb-5">
              <v-col cols="12">
                <v-select
                  :items="templates"
                  label="Template"
                  item-text="caminhoCompleto"
                  item-value="id"
                  v-model="grupo.templateID"
                  :rules="[rules.required]"
                  required
                  :disabled="templates.length <= 0 || grupo.id !== 0"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="mb-5">
              <v-col cols="12">
                <v-text-field
                  v-model="grupo.nome"
                  label="Nome"
                  clearable
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <p>
              <v-btn @click="voltar" color="error" large>Voltar</v-btn>
              <v-btn
                @click="salvar"
                color="primary"
                large
                class="ml-2"
                :disabled="saving"
                >Salvar</v-btn
              >
            </p>
          </v-container>
        </v-form>
      </v-col>

      <v-divider vertical></v-divider>

      <v-col v-if="this.grupo.id !== 0">
        <v-form v-model="validProp" ref="formPropInteligente">
          <v-container>
            <v-row>
              <v-col cols="8">
                <v-select
                  v-model="propriedadeInteligente"
                  :items="propriedadesInteligentes"
                  item-text="nome"
                  item-value="id"
                  label="Propriedades Inteligentes"
                ></v-select>
              </v-col>
              <v-col cols="4" class="pt-5">
                <v-btn
                  @click="salvarPropriedadeInteligente()"
                  color="primary"
                  :disabled="saving"
                  >Incluir</v-btn
                >
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <h4>Propriedades Inteligentes Vinculadas</h4>
            <v-divider></v-divider>
            <v-chip
              v-for="prop in grupoPropriedades.filter(
                (x) => x.propriedadeInteligenteID != null
              )"
              :key="prop.id"
              class="ma-2"
              close
              color="blue"
              outlined
              @click:close="excluirPropriedade(prop.id)"
            >
              {{ prop.nome }}
            </v-chip>
          </v-container>
        </v-form>
        <v-divider></v-divider>
        <v-form v-model="validProp" ref="formProp">
          <v-container>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="grupoPropriedade.nome"
                  label="Nome Propriedade"
                  clearable
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" class="pt-5">
                <v-btn
                  @click="salvarPropriedadeSimples()"
                  color="primary"
                  :disabled="saving"
                  >Incluir</v-btn
                >
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <h4>Propriedades Vinculadas</h4>
            <v-divider></v-divider>
            <v-chip
              v-for="prop in grupoPropriedades.filter(
                (x) => x.propriedadeInteligenteID == null
              )"
              :key="prop.id"
              class="ma-2"
              close
              color="green"
              outlined
              @click:close="excluirPropriedade(prop.id)"
            >
              {{ prop.nome }}
            </v-chip>
            <v-divider></v-divider>
            <h4>Configurações do Grupo</h4>
            <v-divider></v-divider>
            <v-container fluid>
              <v-checkbox
                v-model="grupo.padraoEmpresa"
                label="Padrão Empresa"
                :disabled="!verificarPermissao(2)"
                 @click="confirmarAlterarPadraoEmpresa(grupo.id)"
              ></v-checkbox>

              <v-checkbox
                v-model="grupo.prioridade"
                label="Grupo Prioridade"
                :disabled="!verificarPermissao(2)"
                @click="confirmarAlterarPrioridade(grupo.id)"
              ></v-checkbox>
            </v-container>
              
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <TelaLoading :overlay="saving"></TelaLoading>
  </v-card>
</template>

<script>
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";
import IconeSelect from "@/views/components/IconeSelect.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import { SET_LOADING } from "@/store/config.module";

export default {
  name: "grupoCadastro",
  data() {
    return {
      valid: false,
      saving: false,
      validProp: false,
      cliente: {},
      grupo: {
        id: 0,
        nome: "",
        departamentoID: 0,
        templateID: 0,
        icone: null,
      },
      propriedadesInteligentes: [],
      propriedadeInteligente: null,
      grupoPropriedades: [],
      grupoPropriedade: {
        id: 0,
        grupoID: 0,
        nome: "",
        propriedadeInteligenteID: null,
      },
      departamentos: [],
      templates: [],
      rules: {
        required: (v) => !!v || "Obrigatório",
      },
    };
  },
  components: {
    TelaLoading,
    IconeSelect,
  },
  methods: {
    listaDepartamentos() {
      return new Promise((resolve) => {
        ApiService.get("departamento/getbyclienteid/" + this.cliente.id).then(
          ({ data }) => {
            resolve(data);

            if (data.success) this.departamentos = data.data;
            else SweetAlert.sweetAlertError(data.errors);
          }
        );
      });
    },
    async salvarPropriedadeInteligente() {
      let propriedade = this.propriedadesInteligentes.find(
        (x) => x.id == this.propriedadeInteligente
      );

      let propriedadeExiste = this.grupoPropriedades.find(
        (x) =>
          x.nome == propriedade.nome &&
          x.propriedadeInteligenteID == propriedade.id
      );

      if (propriedadeExiste) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Propriedade inteligente já vinculada",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }

      if (this.$refs.formPropInteligente.validate()) {
        this.saving = true;
        try {
          await this.salvarPropriedade({
            id: 0,
            grupoID: this.grupoPropriedade.grupoID,
            nome: propriedade.nome,
            propriedadeInteligenteID: propriedade.id,
          });
          this.propriedadeInteligente = null;
        } catch (e) {
          this.saving = false;
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Falha ao cadastrar propriedade",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    },
    async listaTemplates() {
      const { data: result } = await ApiService.get(
        "template/getbydepartamentoidComCaminhoCompleto/" +
          this.grupo.departamentoID
      );

      if (result.success) this.templates = result.data;
      else SweetAlert.sweetAlertError(result.errors);
    },
    async carregarPropriedadesInteligentes() {
      const { data: result } = await ApiService.get("PropriedadeInteligente");

      if (result.success) this.propriedadesInteligentes = result.data;
    },
    verificarPermissao(permissao) {
      return PermissoesService.verificarAcesso(Modulo.Grupo, permissao);
    },

    async confirmarAlterarPadraoEmpresa(grupoID) {
      const self = this;
      Swal.fire({
        title: "Tem certeza que deseja alterar o padrão deste grupo?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
      }).then(function (result) {
        if (result.value) {
          self.atualizarPadraoEmpresa(grupoID);
        }
      });
    },

    async atualizarPadraoEmpresa(grupoID) {
      this.saving = true;

      const { data: result } = await ApiService.put(
        "grupo/updatePadraoEmpresa/" + this.cliente.id + "/" + grupoID + "/" + this.grupo.padraoEmpresa
      );

      this.saving = false;

      Swal.fire({
        position: "center",
        icon: result.success === true ? "success" : "error",
        title:
          result.success === true
            ? "Padrão Empresa Atualizado com Sucesso"
            : "Erro au Atualizar Padrão Empresa",
        showConfirmButton: false,
        timer: 1500,
      });
    },

    async confirmarAlterarPrioridade(grupoID) {
      const self = this;
      Swal.fire({
        title: "Tem certeza que deseja alterar a prioridade deste grupo?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
      }).then(function (result) {
        if (result.value) {
          self.atualizarPrioridade(grupoID);
        }
      });
    },

    async atualizarPrioridade(grupoID) {
      this.saving = true;

      const { data: result } = await ApiService.put(
        "grupo/updatePrioridade/" + this.cliente.id + "/" + grupoID + "/" + this.grupo.prioridade
      );

      this.saving = false;

      Swal.fire({
        position: "center",
        icon: result.success === true ? "success" : "error",
        title:
          result.success === true
            ? "Prioridade grupo Atualizado com Sucesso"
            : "Erro au Atualizar prioridade grupo",
        showConfirmButton: false,
        timer: 1500,
      });

    },

    salvar() {
      let self = this;

      if (this.$refs.form.validate()) {
        this.saving = true;

        if (this.grupo.id === 0) {
          return new Promise((resolve) => {
            ApiService.post("grupo", this.grupo).then(({ data }) => {
              resolve(data);

              if (data.success) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Grupo Cadastrado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.grupo = data.data;
                  self.grupoPropriedade.grupoID = data.data.id;
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          }).finally(async () => {
            this.saving = false;
            await this.carregarPropriedadesInteligentes();
          });
        } else {
          this.grupo.departamento = null;
          this.grupo.template = null;

          return new Promise((resolve) => {
            ApiService.put("grupo/" + this.grupo.id, this.grupo).then(
              ({ data }) => {
                resolve(data);
                if (data.success) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Grupo Alterado com Sucesso!",
                    showConfirmButton: false,
                    timer: 2500,
                  }).then(() => {
                    self.$router.push({ name: "grupo" });
                  });
                } else SweetAlert.sweetAlertError(data.errors);
              }
            );
          }).finally(async () => {
            this.saving = false;
            await this.carregarPropriedadesInteligentes();
          });
        }
      }
    },
    async salvarPropriedade(grupoPropriedade) {
      let self = this;
      if (grupoPropriedade.id === 0) {
        try {
          const { data: result } = await ApiService.post(
            "grupoPropriedade",
            grupoPropriedade
          );

          if (result.success) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Propriedade Cadastrada com Sucesso!",
              showConfirmButton: false,
              timer: 2500,
            })
              .then(function () {
                self.listarPropriedades();
              })
              .finally(() => {
                this.saving = false;
                this.grupoPropriedade.propriedadeInteligenteID = null;
                this.grupoPropriedade.nome = "";
              });
          } else SweetAlert.sweetAlertError(result.errors);
        } catch (e) {
          this.saving = false;
        }
      }
    },
    async salvarPropriedadeSimples() {
      if (this.$refs.formProp.validate()) {
        this.saving = true;
        try {
          await this.salvarPropriedade(this.grupoPropriedade);
        } catch (e) {
          this.saving = false;
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Falha ao cadastrar propriedade",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    },

    buscarGrupo(id) {
      return new Promise((resolve) => {
        ApiService.get("grupo/" + id).then(({ data }) => {
          resolve(data);
          if (data.success) {
            this.grupo = data.data;
            this.grupoPropriedade.grupoID = this.grupo.id;

            this.listaTemplates();
            this.listarPropriedades();
            this.carregarPropriedadesInteligentes();
          } else SweetAlert.sweetAlertError(data.errors);

          this.$store.commit(SET_LOADING, false);
        });
      });
    },

    listarPropriedades() {
      return new Promise((resolve) => {
        ApiService.get("grupoPropriedade/getbygrupoid/" + this.grupo.id).then(
          ({ data }) => {
            resolve(data);

            if (data.success) this.grupoPropriedades = data.data;
            else SweetAlert.sweetAlertError(data.errors);
          }
        );
      });
    },

    excluirPropriedade(id) {
      let self = this;

      Swal.fire({
        title: "Tem certeza que deseja excluir esse registro?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.delete(
              "grupoPropriedade/" + id,
              self.grupoPropriedade
            ).then(({ data }) => {
              resolve(data);
              if (data.success) {
                Swal.fire({
                  position: "center",
                  icon: data.success === true ? "success" : "error",
                  title:
                    data.success === true
                      ? "Propriedade Removida com Sucesso!"
                      : "Não foi possível remover essa Propriedade pois há dados vinculados à ela",
                  showConfirmButton: false,
                  timer: 2000,
                }).then(function () {
                  if (data.success === true)
                    self.grupoPropriedades.splice(
                      self.grupoPropriedades.indexOf(
                        self.grupoPropriedades.find((x) => x.id == id)
                      ),
                      1
                    );
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          });
        }
      });
    },

    voltar() {
      this.$router.push({ name: "grupo" });
    },
  },
  mounted() {
    this.$store.dispatch(SET_LOADING, true);
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));

    this.listaDepartamentos();

    if (this.$route.params.id !== undefined)
      this.buscarGrupo(this.$route.params.id);
    else this.$store.commit(SET_LOADING, false);
  },
  created() {
    let permissao = Permissoes.Incluir;

    if (this.$route.params.id !== undefined) permissao = Permissoes.Editar;

    if (!PermissoesService.verificarAcesso(Modulo.Grupo, permissao)) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
